module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-osaka-2-e0bfd31be7003856c20a7fa14479fa64.png";